import React, { useState, useEffect } from "react";
import { Box, useTheme } from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import { tokens } from "../../theme";
import Header from "../../components/Header";
import { useNavigate } from "react-router-dom";
import { useAlert } from "../../global/AlertContext";
import { useDeleteProductMutation, useGetProductsQuery } from "../../services/productService";
import { productsColumns } from "./config";
import { dataGridStyles, localeText } from "../../utils/dataGridConfig";
import ErrorComponent from "../../components/ErrorComponent";
import SearchFilter from "../../components/SearchComponent";

const Products = () => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const navigate = useNavigate();
  const showAlert = useAlert();

  const [searchTerm, setSearchTerm] = useState("");
  const [paginationModel, setPaginationModel] = useState({
    page: 0,
    pageSize: 10,
  });

  // Fetch data with pagination and search term
  const { data: products, error, isLoading, refetch } = useGetProductsQuery({
    offset: paginationModel.page * paginationModel.pageSize,
    limit: paginationModel.pageSize,
    name: searchTerm, // Use search term
  });
  const [deleteProduct] = useDeleteProductMutation();

  // Re-fetch data when paginationModel or searchTerm changes
  useEffect(() => {
    refetch();
  }, [paginationModel, refetch, searchTerm]);

  const handleDelete = async (id) => {
    try {
      await deleteProduct(id).unwrap();
      refetch();
      showAlert("Producto eliminado", "success");
    } catch (error) {
      showAlert(error.message, "error");
    }
  };

  const handleEdit = async (id) => {
    navigate(`${window.location.pathname}/edit/${id}`);
  };

  const columns = productsColumns(handleEdit, handleDelete, colors);

  if (error) {
    return <ErrorComponent />;
  }

  return (
    <Box m="20px">
      <Header title="Productos" subtitle="Lista de productos" showCreateButton={true} />

      {/* Filter Section */}
      <Box
        display="grid"
        gap="30px"
        gridTemplateColumns="repeat(12, minmax(0, 1fr))"
      >
        {/* Search Filter */}
        <Box sx={{ gridColumn: "span 2" }}>
          <SearchFilter
            onSearchChange={(term) => setSearchTerm(term)} // Pass search term to state
            label="Nombre"
          />
        </Box>
      </Box>

      <Box sx={dataGridStyles(colors)} height="75vh">
        <DataGrid
          columns={columns}
          rows={products?.records || []}
          rowCount={products?.count || 0}
          loading={isLoading}
          pagination
          paginationModel={paginationModel}
          rowsPerPageOptions={[10, 20, 50]}
          pageSizeOptions={[10, 20, 50]}
          paginationMode="server"
          onPaginationModelChange={(newPaginationModel) => {
            setPaginationModel(newPaginationModel);
          }}
          loadingText="Cargando..."
          localeText={localeText}
          disableRowSelectionOnClick
          disableColumnMenu
          disableColumnSorting
        />
      </Box>
    </Box>
  );
};

export default Products;